<template>
  <div class="ces-request-page">
    <div class="page-header">
      <div class="title-area">
        <h2 class="page-title">희망이음 자료요청</h2>
        <p class="page-subtitle">희망이음에서 자료를 자동으로 가져옵니다</p>
      </div>
    </div>

    <div class="under-construction">
      <v-icon size="120" color="grey-lighten-1">mdi-hammer-wrench</v-icon>
      <h2>공사중</h2>
      <p>이 기능은 현재 개발 중입니다.</p>
      <p class="sub-text">빠른 시일 내에 서비스를 제공할 예정입니다.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
